import { clsx } from 'clsx';

export function EditingBadge({ className }: { className?: string }) {
  return (
    <span className={clsx('text-caption-2 bg-ripple px-1 py-1 border-radius-md', className)}>
      editing...
    </span>
  );
}
